/**
 * TalkToast Brand Assets
 * Single source of truth for all asset paths
 */

export const LOGO_ASSETS = {
  // Primary logo variants
  full: '/assets/logo/logo-full.svg',
  fullWhite: '/assets/logo/logo-full-white.svg',
  icon: '/assets/logo/logo-icon.svg',

  // Icon sizes (for favicons, PWA)
  sizes: {
    small: '/assets/logo/sizes/logo-16.png',
    medium: '/assets/logo/sizes/logo-32.png',
    apple: '/assets/logo/sizes/logo-180.png',
    pwa192: '/assets/logo/sizes/logo-192.png',
    pwa512: '/assets/logo/sizes/logo-512.png',
  },
} as const

export const TOASTY_ASSETS = {
  // Toasty mascot - clean vector (no bubble, no text)
  mascot: '/assets/toasty/toasty.svg',
  fallback: '/assets/toasty/toasty.png',
} as const

// Type definitions
export type LogoVariant = 'full' | 'fullWhite' | 'icon'

// Helper functions
export const getLogoAsset = (variant: LogoVariant = 'full'): string => {
  return LOGO_ASSETS[variant]
}

export const getToastyAsset = (): string => {
  return TOASTY_ASSETS.mascot
}

// Brand colors extracted from SVG files
export const BRAND_COLORS = {
  // From logo SVG
  primary: {
    brown: '#523224',      // Dark brown (text)
    toast: '#8C4B2F',      // Medium brown (toast body)
    crust: '#DAA95B',      // Golden brown (crust)
    background: '#ECE6D6', // Cream background
  },
  // From Toasty mascot SVG
  mascot: {
    skin: '#EFC68D',       // Toast skin
    accent: '#E29F34',     // Golden accent
    blush: '#D56C42',      // Cheek blush
    outline: '#503124',    // Dark outline
  },
} as const
